import keyMirror from 'keymirror';

export default keyMirror({
  TOGGLE_PERSON: null,
  UPDATE_ATTACHMENT: null
}, 'ATTACHED_PEOPLE');
